/**
 * Module dependencies.
 */

import { Description } from 'components/atoms/description/description';
import { Image as ImageComponent } from 'components/atoms/image/image';
import { Title } from 'components/atoms/title/title';
import { color } from 'styles/utils/colors';
import styled from '@emotion/styled';

/**
 * Export `Wrapper` styled component.
 */

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 32px;
  cursor: pointer;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
`;

/**
 * Export `ProductWrapper` styled component.
 */

export const ProductWrapper = styled.div`
  flex: 0.5;
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 16px;
  padding: 16px;
  border-radius: 8px;

  transition: all 0.15s ease-in-out;

  &:hover {
    background-color: ${color('primary100')};
    transform: scale(1.02);
  }

  @media (max-width: 640px) {
    flex-direction: column;
  }
`;

/**
 * Export `Image` styled component.
 */

export const Image = styled((props) => {
  return <ImageComponent {...props} cover imgStyle={{ objectFit: 'cover' }} />;
})`
  grid-area: image;
  width: 180px;
  height: 180px;
  overflow: hidden;

  @media (max-width: 640px) {
    margin: 0 auto;
    width: 240px;
    height: 240px;
  }
`;

/**
 * Export `ProductContent` styled component.
 */

export const ProductContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

/**
 * Export `ProductTitle` styled component.
 */

export const ProductTitle = styled(Title)`
  color: ${color('primary400')};
  font-size: 24px;
  font-weight: 100;

  @media (max-width: 640px) {
    text-align: center;
  }
`;

/**
 * Export `ProductDescription` styled component.
 */

export const ProductDescription = styled(Description)`
  font-size: 14px;
  color: ${color('gray500')};
  margin-top: 12px;

  @media (max-width: 640px) {
    text-align: center;
  }
`;
